module.exports = __webpack_public_path__ + "static/media/egg_biaoge.632d8e7b.png";